import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./NewCourse.module.css";
import { Stepper, Step } from "../../../UI/Stepper";
import SelectBaseCourse from "./SelectBaseCourse";
import CopyTocs from "./CopyTocs";
import SelectStudents from "./SelectStudents";
import CourseBuildCompletion from "./CourseBuildCompletion";
import { useNavigate } from "react-router-dom";
import { fetchCoursesData } from "../../../../store/course-actions";

const NewCourse = () => {

    const texts = useSelector(state => state.translate.texts);
    const { courses } = useSelector(state => state.courses);
    const [studyGroup, setStudyGroup] = useState({ id: null, courseId: 0, subject: "", description: "" })
    const [filteredCourses, setFilteredCourses] = useState();
    const dispatch = useDispatch()
    const { homeUrl, applicationId } = useSelector((state) => state.application);

    const { openCourse, newCourse, selectSubject, copyTocs, editStudents, notArrived } = texts;

    const [createComplete, setCreateComplete] = useState(false);
    const [courseSelected, setCourseSelected] = useState(false);

    const navigate = useNavigate()

    useEffect(() => {
        if (!courses?.length && applicationId) {
            dispatch(fetchCoursesData());
        }
    }, [courses, applicationId])

    const handleChangeBaseCourseId = (courseId, color) => {
        setStudyGroup((prevStudyGroup) => ({ ...prevStudyGroup, courseId: courseId, color: color }))
    }

    const handleSetStudyGroupId = (id) => {
        setStudyGroup((prevStudyGroup) => ({ ...prevStudyGroup, id: id }))
        setFilteredCourses(courses.filter(c => c.courseId == studyGroup.courseId && c.id !== id));
    }

    const handleSetStudyGroupName = (subject) => {
        setStudyGroup((prevStudyGroup) => ({ ...prevStudyGroup, subject: subject }))
    }

    const handleChangeStudyGroupDescription = (description) => {
        setStudyGroup((prevStudyGroup) => ({ ...prevStudyGroup, description: description }))
    }

    const onEnd = () => {
        if (studyGroup?.id)
            navigate(`${homeUrl}/courses/${studyGroup.id}`, { state: { fetchCoursesData: true } })
        else
            navigate(`${homeUrl}/courses`)
    }

    const getStepper = () => {
        return (
            <Stepper onEnd={onEnd} title={openCourse} subTitle={createComplete ? studyGroup.subject + ', ' + studyGroup.description : newCourse} arrowOnClick={() => { navigate(-1) }} >
                {
                    [
                        <Step description={selectSubject} buttonText={texts.saveAndContinue}><SelectBaseCourse studyGroup={studyGroup} handleSetStudyGroupId={handleSetStudyGroupId} handleSetStudyGroupName={handleSetStudyGroupName} handleChangeBaseCourseId={handleChangeBaseCourseId} setCourseSelected={setCourseSelected} courseSelected={courseSelected}></SelectBaseCourse></Step>,
                        <Step description={editStudents} buttonText={texts.continue}><SelectStudents studyGroup={studyGroup} studyGroupId={studyGroup.id} handleChangeStudyGroupDescription={handleChangeStudyGroupDescription} newCourse={true}></SelectStudents></Step>,
                        filteredCourses?.length > 0 && <Step description={copyTocs} skipButton={true} buttonText={texts.saveAndContinue}><CopyTocs courses={filteredCourses} studyGroupId={studyGroup.id} ></CopyTocs></Step>,
                        <Step description={notArrived}><CourseBuildCompletion studyGroup={studyGroup} handleChangeStudyGroupDescription={handleChangeStudyGroupDescription} setCourseComplete={setCreateComplete} newCourse={true}></CourseBuildCompletion></Step>,
                    ].filter(s => s).map((s, index) => ({ ...s, key: index }))
                }
            </Stepper>
        )
    }

    return <div className={classes.NewCourse}>
        {getStepper()}
    </div>
}

export default NewCourse;